import React from 'react'

const Video = () => {
  return (
    <>
      <div id="Videos" className="bg-[#ffffff] relative mt-[1750px] sm:mt-[750px] pb-10 flex justify-center">
        <div className="flex flex-col items-center w-full max-w-7xl px-3 sm:px-8">
          <div className="text-center py-10">
            <p className="mb-0 text-5xl font-bold">
             Software Tutorial
            </p>
          </div>
          <div className=" sm:h-[500px] sm:w-full ">
            <iframe
              title="ProductVideo"
              src="https://www.youtube.com/embed/b_ecnPOgI4M"
              className="h-full w-full"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}

export default Video;